// @ts-strict-ignore
import { createContext } from "react";

import type { NextStep, StepDetails, TotalStepCount } from "@shared/types/graphqlGenerated";

interface ModularOnboardingModalData {
  loading: boolean;
  currentStepNumber: number;
  totalStepCount: TotalStepCount;
  currentStep: string;
  nextStep: NextStep;
  nextStepText: (marginTypeOverride?: "never" | "variable") => string;
  marginType: string;
  previousStep: string;
  canGoBack: boolean;
  stepDetails: StepDetails[];
  isSetupComplete: boolean;
  currentSetupPage: string;
  goBack: () => void;
  goNext: () => void;
}

const ModularOnboardingModalContext = createContext<ModularOnboardingModalData>(null);

export type { ModularOnboardingModalData };
export { ModularOnboardingModalContext };
